/**
 * Format a Date as YYYY-MM-DD using LOCAL timezone.
 * Avoids the off-by-one bug from `toLocalIsoDate(Date)` which
 * converts to UTC (so 2026-05-01 00:00 BST → "2026-04-30").
 */
export function toLocalIsoDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Today as YYYY-MM-DD in local TZ. */
export function todayLocalIso(): string {
  return toLocalIsoDate(new Date());
}

/**
 * "This Month" range: 1st of current month → today (NOT end-of-month).
 * Vendors expect month-to-date, not future-inclusive.
 */
export function thisMonthRange(): { dateFrom: string; dateTo: string } {
  const now = new Date();
  const from = new Date(now.getFullYear(), now.getMonth(), 1);
  return { dateFrom: toLocalIsoDate(from), dateTo: toLocalIsoDate(now) };
}

/** "Last Month" range: 1st of previous month → last day of previous month. */
export function lastMonthRange(): { dateFrom: string; dateTo: string } {
  const now = new Date();
  const from = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const to = new Date(now.getFullYear(), now.getMonth(), 0); // day 0 of current = last day of prev
  return { dateFrom: toLocalIsoDate(from), dateTo: toLocalIsoDate(to) };
}
